import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import Paginate from "../Atomics/Paginate/Paginate";
import PostExcerpt from "./PostExcerpt";
import { useContext } from "react";
import LoadingIndicator from "../Atomics/Loading/Loading";
import { BlogContext } from "../../context/blog";

export default function BlogFeed() {
  const { blogPosts, loading, totalCount, paginationInfo, handlePageChange } =
    useContext(BlogContext);

  return (
    <>
      <Col md={12} style={{ marginTop: "20px" }}>
        <SectionHeader heading="روایت پیشرفت" />
      </Col>
      <Col md={8} style={{ minHeight: "calc(100vh - 190px)" }}>
        {loading ? (
          <LoadingIndicator />
        ) : blogPosts.count > 0 ? (
          blogPosts?.results?.map((item, index) => (
            <PostExcerpt
              key={index}
              postTitle={item.title}
              publishedOn={item.published_date}
              postExcerpt={item.summary}
              imgSrc={item.cover_article}
              category={item.category.name}
              viewCount={item.counted_view}
              postId={item.id}
            />
          ))
        ) : (
          <p style={{ textAlign: "right" }}>پستی وجود ندارد.</p>
        )}

        {blogPosts.count > 0 && (
          <Paginate
            count={totalCount}
            value={paginationInfo}
            onPageChange={handlePageChange}
            limit={12}
          />
        )}
      </Col>
    </>
  );
}
